import { TabContext as MuiTabContext, TabContextProps as MuiTabContextProps } from "@mui/lab";
import { styled } from "@mui/material";

const StyledTabContext = styled(MuiTabContext)(() => ({
  // ... existing styles
}));

interface TabContextProps extends MuiTabContextProps {
  children: React.ReactNode;
}

export const TabContext: React.FC<TabContextProps> = ({ children, ...props }) => {
  return <StyledTabContext {...props}>{children}</StyledTabContext>;
};

export default TabContext;
